<template>
  <base-section id="theme-features">
    <base-section-heading title="FAQ">
      Volumetric Capture is a brand-new technology and we get questions about what we do all the time. Here are some frequently asked questions.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            {{feature.test}}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>

</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'What is a Volumetric Capture Studio?',
          icon: 'mdi-rotate-3d',
          text: 'In the 360 degree volumetric capture facility, the 4DViews HOLOSYS system films the asset from multiple angles generating a virtual 3D object of the recorded sequence, making real performances applicable in multiple platforms.',
        },
        {
          title: 'What is HOLOSYS',
          icon: 'mdi-map-marker-question',
          text: 'Holosys is a fully-packaged equipment system, including 4DViews hardware for performance capture and system software to generate high-quality, high-fidelity volumetric video sequences',
        },
        {
          title: 'How Efficient is Volumetric Capture',
          icon: 'mdi-chart-bell-curve-cumulative',
          text: 'Using only 2 operators, a client such as a music artist can come in, perform their given songs, and be completed with their performance in a day having recorded an album’s worth of songs.',
        },
        {
          color: 'primary',
          // dark: true,
          title: 'What can a 3d Asset be used for?',
          icon: 'mdi-ruler-square-compass',
          text: 'Though many call them holograms, the 3D assets we capture on our stage are much more than just that. 3D assets can be deployed onto multiple platforms such  Virtual Productions, Mobile Apps, Games and Digital Advertising',
        },
        {
          title: 'What COVID Precautions are in place?',
          icon: 'mdi-bacteria',
          text: 'Safety during this time is our top priority, that is why we have streamlined our business to make it easy and effective during shoot days with am extremely light technical crew to capture and render your performance.',
        },
        // {
        //   title: 'How long can you capture',
        //   icon: 'mdi-clock-alert',
        //   text: 'With some of the most powerful hardware in the world, we can capture long continuous shots, our record so far is 24 minutes in a single take!',
        // },
      ],
    }),
  }
</script>
